export const SHARE_MODAL_UPSELL_MESSAGE =
  'Upgrade to unlock link settings like comments, custom fields, and security settings.';

export const INTELLIGENCE_UPSELL_MESSAGE = 'Upgrade to unlock full AI summaries and smart tags.';

export const INTELLIGENCE_STORAGE_LIMIT_MESSAGE =
  "You've reached your 10GB limit. Upgrade to unlock full AI summaries and tags.";

// Chapters-specific messages
export const CHAPTERS_STORAGE_LIMIT_MESSAGE =
  "You've hit your 10GB upload limit. Upgrade to continue using AI-powered chapterization.";

export const CHAPTERS_ADDON_UPSELL_MESSAGE = 'Upgrade to unlock AI-powered chapterization.';

export const CHAPTERS_PROCESSING_MESSAGE = 'Generating video chapters. Check back soon!';

export const CHAPTERS_NO_DATA_MESSAGE = "We couldn't generate chapters for this video.";

export const CHAPTERS_UNSUPPORTED_MESSAGE = "Smart metadata isn't yet supported for this file's size or format.";
// Transcript-specific messages
export const TRANSCRIPT_STORAGE_LIMIT_MESSAGE =
  "You've hit your 10GB upload limit. Upgrade to continue using AI-powered transcription.";
export const TRANSCRIPT_ADDON_UPSELL_MESSAGE = 'Upgrade to unlock AI-powered transcription.';
export const TRANSCRIPT_PROCESSING_MESSAGE = 'Transcribing audio…';
export const TRANSCRIPT_NO_DATA_MESSAGE = "No speech detected. We couldn't create a transcript for this file.";

// Image Search messages (combined OCR and Facial Recognition)
export const IMAGE_SEARCH_PROCESSING_MESSAGE = 'Scanning for people and text…';
export const IMAGE_SEARCH_NO_DATA_MESSAGE = "We couldn't detect any people or text in this file.";
export const IMAGE_SEARCH_ADDON_UPSELL_MESSAGE = 'Upgrade to unlock facial recognition.';
export const IMAGE_SEARCH_STORAGE_LIMIT_MESSAGE = 'Upgrade to continue using facial recognition.';
